import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import styles from "../../../pages/Admin/Admin.module.css";
import {useModal} from "../../../contexts/ModalContext";
import {useNavigate} from "react-router-dom";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchEntreprise from "../../Search/SearchEntreprise";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {generateCsv, handleSubmitCsvUsers} from "../../../services/FileService";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import styles_modal from "../../Modal/Modal.module.css";
import AxiosConfig from "../../../services/AxiosConfig";

function UtilisateursCreationEnMasse({utilisateur = null, searchParams = null}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [roles, setRoles] = useState([]);
    const [civilites, setCivilites] = useState([]);
    const initialRoles = utilisateur?.roles || [];
    const [entreprise, setEntreprise] = useState({id: null, nom: null});
    const [generatePassword, setGeneratePassword] = useState("");
    const initialValuesCsvUsers = {
        file: null,
    };
    let navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 4000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 4000});
    };

    const handleSubmitCsvUsersPrep = async (values) => {
        if (!entreprise) {
            handleError('Veuillez sélectionner une entreprise.');
            return;
        }
        const file = values.file;
        if (!file) {
            handleError('Veuillez sélectionner un fichier CSV.');
            return;
        }

        showModal('classic', {
            children:
                <div style={{ padding: "48px" }}>
                    <h3 className={"titleAlert"}>En cas de mail déjà existant ?</h3>
                    <div className={styles_modal.btnChoiceBar}>
                        { loading === false && <>
                            <button className="btn btn_main" onClick={() => handleSubmitCsvUserss(values, true)}>Mettre
                                à jour l'utilisateur
                            </button>
                            <button className="btn btn_main"
                                    onClick={() => handleSubmitCsvUserss(values, false)}>Ignorer l'utilisateur
                            </button>
                        </>}
                    </div>
                </div>
        });
    }

    const handleSubmitCsvUserss = async (values, overwrite = false) => {
        setLoading(true);
        const entrepriseId = entreprise.entrepriseId ?? entreprise.id;
        const response = await handleSubmitCsvUsers(values, entrepriseId, overwrite);
        if (response.success) {
            handleSuccess(response.msg);
        } else {
            handleError(response.msg);
        }
        setLoading(false);
    }

    // useEffect pour voir si un queryparam "entreprise" existe et si oui setEntreprise sur la value
    useEffect(() => {
        const entrepriseId = searchParams.get('entreprise');
        if (entrepriseId) {
            (async () => {
                const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}`);
                if (response?.data) {
                    setEntreprise({id: response.data.myEntreprise.id, nom: response.data.myEntreprise.nom});
                } else {
                    handleError("L'entreprise n'existe pas");
                }
            })();
        }
    }, [searchParams]);

    return (
        <div style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #ccc"
        }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
            }}>
                <TitleSecondary text="Création de compte en masse"/>
                <button onClick={generateCsv} style={{width: "90px", height: "30px", fontSize: "0.75rem"}}>
                    <FontAwesomeIcon icon={faDownload}/> Modèle CSV
                </button>
            </div>

            <div>
                <p>Entreprise</p>
                <SearchEntreprise selectedEntreprise={{ id: entreprise?.entrepriseId, nom: entreprise?.nom}} onSubmit={(e) => {
                    setEntreprise({id: e.entrepriseId, nom: e.query});
                }} placeholder={"Recherchez une entreprise"}/>
                <p style={{fontSize: "var(--fs-secondary", marginTop: "6px"}}>
                    Entreprise séléctionnée : <span style={{fontWeight: "bold"}}>{entreprise ? entreprise.nom : "Aucune"}</span>
                </p>
            </div>

            <Formik initialValues={initialValuesCsvUsers} onSubmit={handleSubmitCsvUsersPrep}>
                {({setFieldValue, isSubmitting}) => (
                    <Form style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                        <Field name="file">
                            {({field}) => (
                                <input
                                    type="file"
                                    accept=".csv"
                                    name="file"
                                    onChange={(event) => {
                                        setFieldValue("file", event.currentTarget.files[0]);
                                    }}
                                    style={{ outline: "1px solid var(--clr-accent)", padding: "10px", borderRadius: "5px" }}
                                />
                            )}
                        </Field>
                        <div className={"barre_btn"}>
                            <button type={"button"} onClick={() => {
                                navigate(-1)
                            }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                            </button>
                            <button type="submit" className={styles.btnFileLogo}>Envoyer le fichier CSV</button>
                        </div>
                    </Form>
                )}
            </Formik>

            <p style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <span>Le fichier CSV doit etre separe par des points-virgules</span>
                <span style={{
                    width: "32px",
                    height: "32px",
                    margin: "7px",
                    display: "inline-block",
                    textAlign: "center",
                    lineHeight: "32px",
                    backgroundColor: "#c2dcea",
                    color: "#000",
                    borderRadius: "5px",
                }}>;</span>
            </p>
        </div>
    );
}

export default UtilisateursCreationEnMasse;